import Dashboard from '../../../views/practice/dashboard/Dashboard'

const dashboardRoutes = [
  {
    path: '/practice/dashboard',
    element: <Dashboard />
  }
];

export default dashboardRoutes;
